/**
 * File forms.js.
 *
 * Helps with all the forms and its validations.
 */

/**
 * Defining a factory to read jQuery functions
 * This is closed at the end of the document:
 * 
 *		return $;
 *	}));
 *
 */
(function( factory ) { 
	factory( jQuery );
}(function( $ ) {


/*
 * Auxiliary validate Functions for jQuery Validate ------------ *
 */
	// US and CA Phone Number Validation
	$.validator.addMethod("phoneNumber", function (value, element) {
		return this.optional(element) || /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(value);
	}, "Invalid Phone Number");

	// No Alphanumeric Validation
	$.validator.addMethod("lettersOnly", function (value, element) {
		return this.optional(element) || /^[a-zA-Z\s]+$/i.test(value);
	}, "Letters only please");

	// US and CA Zip Code Validation
	$.validator.addMethod("zipCode", function(value, element) {
		return this.optional(element) || /\d{5}-\d{4}$|^\d{5}$/.test(value);
	}, "Invalid zip code");
/* ---- End of auxiliary validation functions ------------------- */

( function() {

    //Jquery Validate
    $("#form-to-validate").validate({
        rules: {
            inputPassword4: {
                required: true
            },
            inputEmail4: {
                required: true,
                email: true
            },
            inputAddress:{
                required: true
            },
            inputPhone: {
                required: true,
                phoneNumber: true
            },
            inputCity: {
                required: true,
                lettersOnly: true
            },
            inputZip:{
                required: true,
                zipCode: true
            },
            inputTextArea:{
                required: true
            }
        },
        messages: {
            inputPassword4: {
                required: 'Password is required OK',
            },
            inputEmail4: {
                required: 'Email is a required field',
                email: 'Wrong format for an email'
            },
            inputPhone: {
                required: 'Insert a Phone number please',
                phoneNumber: 'This is not a valid Mobile phone number'
            },
            inputAddress: {
                required: 'You need to provide your address'
            },
            inputCity: {
                required: 'You need to provide your address',
                lettersOnly: 'Incorrect City, Check your string, it has incorrect values',
            },
            inputZip:{
                required: 'The zip code is needed',
                zipCode: 'Wrong zip code value'
            },
            inputTextArea:{
                required: 'Empty field not supported'
            }
        },

        errorPlacement: function (error, element) {
            error.appendTo("label[for=" + $(element).attr('id') + "]");
        },
        errorElement: "span", //formErrorMsg

        submitHandler: function (form, event) {
            event.preventDefault();

            var formID = $(form).attr('id');

            console.log( 'Do something here with this form:'+formID );

            return false;
        }

    });




    /* ---- End of auxiliary validation functions ------------------- */

} )();

return $;
})); //End of the file


// WEBPACK FOOTER //
// ./src/js/forms.js